$(function() {
	// Initialize the editor
	const $textarea = $('#comment-field');
	const token = window.location.pathname.split('/').pop();
	const localStorageKey = `autosave/comment/${token}`;
	let autoSavedComment = localStorage.getItem(localStorageKey);
	$textarea.editor({ preview: true });

	function autoFiles(files) {
		const finalHtml = files.map(({ id, file_name, thumbnail_location, location, filesize, checked }) => {
			return `<div class="file-row" id="file_${id}">
				<label for="files[${id}][location]" class="field-checkbox"> 
					<input type="checkbox" ${checked ? 'checked' : ''} class="insert-check c" id="files[${id}][location]" name="files[${id}][location]" value="${location}"> 
					<span></span> 
				</label>
				<input type="hidden" name="files[${id}][original_name]" value="${file_name}">
				<input type="hidden" name="thumbnails[${id}]" value="${thumbnail_location}">
				<span class="wrap">
					<span class="filename">${file_name}</span>
				</span> 
				<span class="filesize">${filesize}</span>
			</div>`;
		}).join('');
		const target = document.querySelector('.uploaded-files');
		if(target.dataset.enableHistory) {
			target.insertAdjacentHTML('afterbegin', finalHtml)
		}
	}

	$textarea.on('keyup', function() {
		const value = $(this).val();
		const localItem = localStorage.getItem(localStorageKey);
		let localItemObj;

		if(localItem) {
			localItemObj = JSON.parse(localItem);
		} else {
			localItemObj = {
				message: '',
				note: '',
				files: []
			}
		}

		if($textarea.closest('form').find('[name="comment_type"]').length) {
			localItemObj.note = value;
		} else {
			localItemObj.message = value;
		}

		localStorage.setItem(localStorageKey, JSON.stringify(localItemObj));
	})

	// toggle expand all comments
	var is_expanded = false;
	var hidden_comments = $('li.hidden-comments');
	var $expandAll = $('.expand-all');

	$('.expand-all').click(function(){
		if (!is_expanded) {
			window.$eventDispatcher.$emit('comments:expandAll');
			is_expanded = true;
		} else {
			window.$eventDispatcher.$emit('comments:collapseAll');
		}

		return false;
	});

	window.$eventDispatcher.$on('comments:expandedAll', function() {
		is_expanded = true;
		$expandAll.html('<i class="icon icon-chevrons-collapse"></i>');
	});

	window.$eventDispatcher.$on('comments:collapsedAll', function() {
		is_expanded = false;
		$expandAll.html('<i class="icon icon-chevrons-expand"></i>');
	});

	// expand all comments when a status log comment link is clicked
	$('.status-log ul a').click(function(){
		// check if the comments are already expanded
		if (is_expanded) {
			return true;
		}

		$('.expand-all').trigger('click');
	});


	// show the textarea
	$('.submit-comment textarea').focus(function(){
		var submit_comment = $(this).closest('.submit-comment');
		if( submit_comment.hasClass('submit-smaller') ) {
			submit_comment.removeClass('submit-smaller');

			$(this).css('height', $(window).height()/2.5);

			$('.submit-comment textarea').trigger("textarea-expanded");

			// position to textarea
			var submit_h = $('.submit-comment').outerHeight(false);
			var top = $('.submit-comment').offset().top;

			var newTop = top + submit_h - $(window).height() + 4;
			var ua = navigator.userAgent;

			if(ua.indexOf('iPhone') !== -1 || ua.indexOf('iPad') !== -1 || ua.indexOf('iPod') !== -1) {
				newTop += 200;

				setTimeout(function() {
					$('html, body').animate({
						scrollTop: newTop
					}, 1);
				})
			} else {
				$(window).scrollTop(top + submit_h - $(window).height() + 4);
			}
		}
	});


	// cancel comment
	$('input[type=button][name=discard]').click(function(){
		$('.submit-comment textarea').val('').css('height', 90).css('width', '90%').trigger('input');
		$('.submit-comment').addClass('submit-smaller');
		if ($('#previewed_comment').length) {
			$('#previewed_comment').remove();
		}
		$('.submit-comment textarea').trigger("textarea-collapsed");
		localStorage.removeItem(localStorageKey);
		return false;
	});


	// show the textara
	$('input[type=button][name=write_comment], .reply').on('click', function(){
		$('.submit-comment textarea').focus();
		$('body').removeClass('sidebar-open');
		return false;
	});


	// show project status
	$('input[type=checkbox][name=update_project_status]').change(function() {
		$('#project-status-field').toggle( $(this).is(':checked') );
	});


	$('div.projects a.star-ctrl').on('click', function() {
		var url = $(this).attr('href');
		var anchor = $(this);
		$.ajax({
			url: url,
			type: 'GET',
			success: function(r){
				anchor.toggleClass('has-star');
			}
		});
		return false;
	});


	// Submit comment
	$('#comment-form').submit(function() {
		var the_form = $(this);
		var message = $(this).find('textarea[name=comment]');

		if ( message.val() == '' ) {
			alert("Please, enter your comment");
			message.focus();
			the_form.data("not-valid", true);
			return false;
		}

		if (typeof FileReader == "undefined") {
			// let standard form submit for browsers that
			// does not support the File API
			the_form.find('input[type=submit]').attr('disabled', true);
			return true;
		}


		var data = $(this).serializeArray();
		var url = $(this).attr('action');
		var message_val = message.val();

		the_form.get(0).reset();

		$('#new-comment-loader').show();
		message.val("Loading...");

		msgMonitor.stop();

		the_form.trigger('pre_ajax_request');

		$.ajax({
			url: url,
			data: data,
			dataType: "json",
			type: "POST",
			success: function(response) {
				window.$eventDispatcher.$emit('comments:added', response.comment_id);

				the_form.get(0).reset();
				the_form.trigger('ajax_request_completed');
				the_form.find('#comment-field').trigger('input');

				msgMonitor.setLastComment(response.comment_id);
				localStorage.removeItem(localStorageKey);

				if ($('#previewed_comment').length) {
					$('#previewed_comment').remove();
				}
			},
			error: function( response, status ) {
				the_form.get(0).reset();
				the_form.trigger('ajax_request_completed');
				message.val( message_val )
				
				if(response.status === 401) {
					alert( 'You need to be logged in' );
				} else {
					alert( 'Error: '  + response.responseText );
				}

			},
			complete: function() {
				msgMonitor.start();
			}
		});

		return false;
	});


	$('#comment-form').submit(function () {
		$(this).data('submitted', 1);
	});


	$('#comment-form').bind('reset', function () {
		$(this).data('submitted', null);
		$(this).find('input[type=checkbox]').trigger('change');
	});



	// Handles "Mark as Read" button on individual project
	$('#mark-as-read-btn').click(function() {
		var self = $(this);
		$.ajax({
			url: window.location.toString().replace(/#.*/, '') + '/switch-read-status/',
			type: "GET",
			data: {
				// switch read status just flips the status by default.
				// This param forces new status to be "read"
				"force-new-status": "read"
			},
			success: function(r) {
				$('div.comment-head').removeClass("unread");
				self.hide();
			},
			error: function(jqXHR, textStatus) {
				alert("Couldn't complete your request.\nError: " + textStatus);
			}
		});
	});


	// Handles manual read / unread project marking on projects listing page
	$('body').on('click', 'div.projects a.read-status', function() {
		var url = $(this).attr("href"),
			tr = $(this).closest('tr');

		$.ajax({
			url: url,
			type: "GET",
			success: function(r) {
				update_unread_messages_count(r);
				var is_unread = tr.hasClass('unread');
				tr.toggleClass('unread').attr('title', "Mark as " + (is_unread ? 'read' : 'unread'));
			},
			error: function(jqXHR, textStatus) {
				alert("Couldn't complete your request.\nError: " + textStatus);
			}
		});
		return false;
	});


	// Handles manual read / unread comment marking on individual project page
	$('li.comment a.read-status').click(function() {
		var c = $(this).closest('div.comment-head'),
			new_status = c.hasClass('unread') ? 'read' : 'unread';
		$.ajax({
			url: '/change-comment-status',
			type: "POST",
			data: {
				new_status: new_status,
				object_id: c.parent().attr('data-commentid')
			},
			success: function(r) {
				c.toggleClass('unread');
				if ($('div.comment-head.unread').length==0) {
					$('#mark-as-read-btn').hide();
				} else {
					$('#mark-as-read-btn').show();
				}
			}
		});
		return false;
	});

	// Handles multiply comments mark as read
	$('input[name=mark_as_read], button[name=mark_as_read]').click(function(){
		var checks = $('.projects input[type=checkbox]:checked');
		if( checks.length == 0 ) {
			alert('Please select at least one project.');
			return false;
		}

		var ids = [];
		var trs = checks.parents('tr');
		trs.each(function(){
			ids.push( $(this).attr('data-id') );
		});

		$.post('/projects/mark-as-read',{ 'project_ids': ids }, function(r){
			trs.removeClass('unread');
			msgMonitor.check();
		});

		return false;
	});

	// AutoComment
	if(autoSavedComment) {
		autoSavedComment = JSON.parse(autoSavedComment);
		$textarea.focus().val(autoSavedComment.message).blur();
		if(autoSavedComment.files) {
			autoFiles(autoSavedComment.files)
		}
	}

	$('.uploaded-files').on('change', '.insert-check', function() {
		if(!autoSavedComment) {
			autoSavedComment = localStorage.getItem(localStorageKey);
			autoSavedComment = JSON.parse(autoSavedComment);
		}
		const file = autoSavedComment?.files?.find(item => item.location === $(this).val());

		if(file) {
			file.checked = $(this)[0].checked;
			localStorage.setItem(localStorageKey, JSON.stringify(autoSavedComment));
		}
	})
});
